/* eslint-disable @typescript-eslint/no-unused-vars */
import { Loader, TableActionHeader } from "components/Global";
import ConfirmDelete from "components/Global/confirmDeleteModel";
import { PermissionsNames, userColumns } from "constants/Data";
import { ChangeEvent, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  GetIpWhteList,
  DeleteIpWhteList,
} from "redux/action/ipWhiteListAction";
import { userCheck } from "redux/slice/userCheckSlice";
import { AppDispatch } from "redux/store";
import { AddSvg } from "utils/svgs";
import { checkPermission } from "utils/utils";
import DynamicTable from "./Table";
import styles from "./index.module.scss";
import IPWhiteListPopup from "./popUp";

// UsersTable component
const UsersTable = () => {
  // State variables
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [PageSize, setPageSize] = useState(
    Number(localStorage.getItem("userTableSize")) || 20
  );
  const [filterValue, setFilterValue] = useState("all");
  const [type, setType] = useState("asc");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editSelectedUser, setEditSelectedUser] = useState<any>();
  const [formateData, setFormateData] = useState<any>([]);
  const [sortDirection, SetsortDirection] = useState("ascend");

  const [isIpPopUpOpen, setIsIpPopUpOpen] = useState(false);

  // Dispatch
  const dispatch = useDispatch<AppDispatch>();

  // Location and Navigation
  const location = useLocation();
  const navigate = useNavigate();
  const {
    data: userData,
    isLoading,

    fistTimeFetchLoading,
  } = useSelector((state: any) => state.IpWhiteList);

  const totalRecords = useSelector((state: any) => state?.IpWhiteList?.count);
  const selectedCompany = useSelector(
    (state: any) => state?.userProfile?.data?.companies
  );
  const selectedCompanyPermission = useSelector(
    (state: any) => state?.userProfile?.data?.companies[0]?.role?.permissions
  );

  // Permission handling
  const PermssionForSelectedCompanay = selectedCompany?.map((data: any) => {
    if (data.companyId === localStorage.getItem("companyId")) {
      return data.role.permissions;
    }
  });
  let DashboardPermission;
  if (PermssionForSelectedCompanay) {
    DashboardPermission = PermssionForSelectedCompanay[0]?.find((data: any) => {
      return data.permissionName === PermissionsNames.ManageIPWhitelisting;
    });
  }

  // Check view permissions
  const hasViewPermission = checkPermission(selectedCompanyPermission, {
    permissionName: PermissionsNames.ManageUser,
    permission: ["view"],
  });

  // Check view permissions based on location
  useEffect(() => {
    if (
      location.pathname.startsWith("/whiteListedIp") &&
      selectedCompanyPermission?.length
    ) {
      if (!hasViewPermission) {
        navigate("/");
      }
    }
  }, [location, selectedCompanyPermission?.length]);

  // Format user data
  useEffect(() => {
    if (userData?.data?.length === 0 && currentPage > 1) {
      const query: any = {
        page: currentPage - 1,
        limit: PageSize,
        search: searchValue,
        filter: filterValue,
        sort: type,
        type: sortDirection === "ascend" ? "asc" : "desc",
      };

      if (filterValue === "all") {
        delete query?.filter;
      }

      dispatch(GetIpWhteList(query)).then((res: any) => {
        if (res?.payload?.error?.status === 401) {
          const response = {
            isLoggedIn: true,
            isErrorMessage: res?.payload?.error?.message,
          };
          dispatch(userCheck(response));
        }
      });
      setCurrentPage(currentPage - 1);
    }

    setFormateData(userData.data);
  }, [userData]);

  // Fetch roles

  // Fetch user data
  const fetchUsers = () => {
    const query: any = {
      page: currentPage,
      limit: PageSize,
      search: searchValue,
      filter: filterValue,
      sort: "fullName",
      type: type,
    };

    if (filterValue === "all") {
      delete query.filter;
    }

    dispatch(GetIpWhteList(query)).then((res: any) => {
      if (res?.payload?.error?.status === 401) {
        const response = {
          isLoggedIn: true,
          isErrorMessage: res?.payload?.error?.message,
        };
        dispatch(userCheck(response));
      }
    });
  };

  useEffect(() => {
    fetchUsers();
  }, [PageSize, currentPage, filterValue, searchValue, type]);

  // Handle search operation
  const performSearchHandler = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setSearchValue(value);
    setCurrentPage(1);
  };

  // Handle sorting operation
  const performSortHandler = (type: string) => {
    console.log("🚀 ~ performSortHandler ~ type:", type);
    if (type !== sortDirection) {
      SetsortDirection(type);
      setType(type === "ascend" ? "asc" : "desc");
      setCurrentPage(1);
    }
  };

  // Handle pagination for the table
  const paginationChangeHandler = (pageNo: number, pageSize: number) => {
    setCurrentPage(pageNo);
    setPageSize(pageSize);
  };

  // Modify the page size
  const modifyPageSize = (current: number, size: number) => {
    if (!size) {
      setPageSize(10);
    } else {
      setPageSize(size);
      localStorage.setItem("userTableSize", size.toString());
    }
    setCurrentPage(1);
  };

  // Open the modal
  const showModal = () => {
    setIsModalOpen(true);
  };

  const AddIp = () => {
    console.log("AddIp");
  };
  const close = () => {
    setIsIpPopUpOpen(false);
  };

  // Confirm operation
  const handleOk = () => {
    console.log("HandleOk", editSelectedUser);
    //
  };

  // Cancel operation
  const handleCancel = () => {
    !isLoading && setIsModalOpen(false);
  };

  // Delete user
  const deleteHandler = () => {
    if (editSelectedUser) {
      dispatch(DeleteIpWhteList(editSelectedUser)).then(() => {
        !isLoading && setIsModalOpen(false);
        !isLoading && setEditSelectedUser(undefined);
        dispatch(GetIpWhteList());
      });
    }
  };

  // JSX
  return (
    <>
      <div className={styles["user-table"]}>
        {!fistTimeFetchLoading ? (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "16px",
                marginTop: "15px",
              }}
            >
              <div>
                <h2
                  style={{
                    margin: 0,
                    fontSize: "22px",
                    fontWeight: 600,
                  }}
                >
                  IP Whitelist Management
                </h2>
                <p
                  style={{
                    color: "#9CA3AF",
                    fontSize: "14px",
                    marginTop: "4px",
                  }}
                >
                  Control which IP addresses have access to your resources
                </p>
              </div>

              {localStorage.getItem("companyId") !== "undefined" &&
                DashboardPermission?.add && (
                  <button
                    className={`btn-blue ${styles["user-table__action--button"]}`}
                    onClick={() => setIsIpPopUpOpen(true)}
                  >
                    <AddSvg />
                    <p>Add Ip Address</p>
                  </button>
                )}
            </div>
            <div>
              <DynamicTable
                ipDataSource={formateData}
                userColumns={userColumns}
                paginationChangeHandler={paginationChangeHandler}
                currentPage={currentPage}
                totalRecords={totalRecords}
                performSearchHandler={performSearchHandler}
                searchValue={searchValue}
                showModal={showModal}
                setEditSelectedUser={setEditSelectedUser}
                performSortHandler={(type: any) => performSortHandler(type)}
                performFilterHandler={(value) => setFilterValue(value)}
                filterValue={filterValue}
                permissions={DashboardPermission}
                PageSize={PageSize}
                modifyPageSize={modifyPageSize}
                sortDirection={sortDirection}
                isLoading={isLoading}
                isAddUserLoading={isLoading}
              />
            </div>
          </div>
        ) : (
          <Loader />
        )}
      </div>
      <ConfirmDelete
        handleCancel={handleCancel}
        handleOk={handleOk}
        isModalOpen={isModalOpen}
        deleteHandler={deleteHandler}
        // isLoading={isLoading}
        isAddUserLoading={isLoading}
      />
      <IPWhiteListPopup
        editFormValue={AddIp}
        isModalOpen={isIpPopUpOpen}
        handleClose={close}
      />
    </>
  );
};

export default UsersTable;
